module.exports = __webpack_public_path__ + "img/GBS_MOD-BUS.302e0940.svg";